import { render, staticRenderFns } from "./CarrierManagement.vue?vue&type=template&id=71b35ba5&"
import script from "./CarrierManagement.vue?vue&type=script&lang=js&"
export * from "./CarrierManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports